/**
 * UTM Tracker — detecta la fuente de tráfico al entrar a la web
 * y la guarda en localStorage para adjuntarla a la siguiente venta.
 *
 * Soporta:
 *  - Parámetros UTM estándar (?utm_source=instagram&utm_medium=social)
 *  - Referrer automático (instagram.com, tiktok.com, facebook.com, google.com)
 *  - Sin fuente detectada → DIRECTO
 */

export type CanalOrigen = 'WEB' | 'INSTAGRAM' | 'TIKTOK' | 'FACEBOOK' | 'GOOGLE' | 'WHATSAPP' | 'PRESENCIAL'

const KEY = 'aqua_canal_origen'
const KEY_TS = 'aqua_canal_ts'
const TTL_MS = 30 * 60 * 1000 // 30 minutos de sesión

function detectarCanal(): CanalOrigen {
  const params = new URLSearchParams(window.location.search)
  const utmSource = (params.get('utm_source') ?? '').toLowerCase()

  if (utmSource.includes('instagram')) return 'INSTAGRAM'
  if (utmSource.includes('tiktok'))    return 'TIKTOK'
  if (utmSource.includes('facebook'))  return 'FACEBOOK'
  if (utmSource.includes('google'))    return 'GOOGLE'
  if (utmSource.includes('whatsapp'))  return 'WHATSAPP'

  const ref = (document.referrer ?? '').toLowerCase()
  if (ref.includes('instagram.com'))   return 'INSTAGRAM'
  if (ref.includes('tiktok.com'))      return 'TIKTOK'
  if (ref.includes('facebook.com') || ref.includes('fb.com')) return 'FACEBOOK'
  if (ref.includes('google.com') || ref.includes('google.co')) return 'GOOGLE'
  if (ref.includes('wa.me') || ref.includes('whatsapp.com')) return 'WHATSAPP'

  return 'WEB'
}

/** Llamar una vez al iniciar la app */
export function initUTMTracker(): void {
  const ts = localStorage.getItem(KEY_TS)
  const yaVencio = !ts || Date.now() - Number(ts) > TTL_MS

  // Solo sobreescribir si la sesión venció o si hay UTMs nuevos en la URL
  const params = new URLSearchParams(window.location.search)
  const tieneUTM = params.has('utm_source') || params.has('utm_medium') || params.has('ref')

  if (tieneUTM || yaVencio) {
    const canal = detectarCanal()
    localStorage.setItem(KEY, canal)
    localStorage.setItem(KEY_TS, String(Date.now()))
  }
}

/** Obtener el canal actual (para adjuntar a una venta) */
export function getCanalOrigen(): CanalOrigen {
  return (localStorage.getItem(KEY) as CanalOrigen) ?? 'WEB'
}

/** Limpiar después de registrar la venta */
export function clearCanalOrigen(): void {
  localStorage.removeItem(KEY)
  localStorage.removeItem(KEY_TS)
}
